export const getCurrentLanguage = (): 'fr'|'en' => {
  if (typeof window === 'undefined') {
    return 'fr';
  }

  const host = window?.location?.host || '';
  const isFrench = host.endsWith('fr');
  return isFrench ? 'fr' : 'en';
};
